"use client";

import { useTranslations } from "next-intl";

interface Props {
  /** id of the main landmark to jump to. Defaults to "main-content". */
  targetId?: string;
}

/**
 * A "skip to main content" link (WCAG 2.4.1 Bypass Blocks).
 *
 * It is visually hidden until it receives keyboard focus, at which point it
 * becomes the first visible, focusable element on the page. Activating it moves
 * focus to the main landmark so keyboard and screen-reader users can bypass the
 * repeated navigation/header on every page.
 */
const SkipToContent = ({ targetId = "main-content" }: Props) => {
  const t = useTranslations("Accessibility");

  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-black focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
    >
      {t("skipToContent")}
    </a>
  );
};

export default SkipToContent;
